module.exports = __webpack_public_path__ + "img/pocket9_pack.6b77775e.png";